// extracted by mini-css-extract-plugin
export var borderRadius = "_5t-4";
export var large = "_5t-3";
export var logoContainer = "_5t-0";
export var nameLogo = "_5t-2";
export var small = "_5t-1";